module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-328.553c0ad.woff2";